export default {
  countData: {},
  recentEntities: {}
}



// WEBPACK FOOTER //
// ./src/modules/stats/store/state.js